<template>
    <transition :css="false"
                @enter="enter"
                @leave="leave"
                @enter-cancelled="enterCancelled"
                @leave-cancelled="leaveCancelled"
    >
        <div v-show="$store.getters['loader/status']"
             ref="loader"
             class="loadingCircleWrap"
        >
            <div class="loaderCircleUnit">
                <div class="loaderCircle">Loading...</div>
            </div>
        </div>
    </transition>
</template>

<script>
import Velocity from 'velocity-animate';

export default {
    name: 'Loader',
    data() {
        return {
            duration: 500,
        };
    },
    mounted() {
    },
    methods: {
        enter(el, done) {
            this.$refs.loader.classList.add('isLoading');
            Velocity(el, {opacity: 1}, {duration: this.duration, mobileHA: false, complete: done});
        },
        leave(el, done) {
            Velocity(el, {opacity: 0}, {
                duration: this.duration,
                mobileHA: false,
                complete: ()=> {
                    this.$refs.loader.classList.remove('isLoading');
                    done();
                },
            });
        },
        enterCancelled(el) {
            Velocity(el, 'stop');
        },
        leaveCancelled(el) {
            Velocity(el, 'stop');
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/modules/variables";

/*
loading
.js_loading をjsで操作する
*/
//.loadingCircleWrap {
//    display: none;
//}
//
.isLoading.loadingCircleWrap {
    display: block;
    z-index: 1000;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.3);
    color: $accent3;
}

.loaderCircleUnit {
    display: none;
}

.isLoading .loaderCircleUnit {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.isLoading .loaderCircle {
    color: var(--accent-color);
    font-size: 3.0rem;
    text-indent: -9999em;
    overflow: hidden;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load6 1.7s infinite ease, round 1.7s infinite ease;
    animation: load6 1.7s infinite ease, round 1.7s infinite ease;
    @media ($min-md) {
        font-size: 3.6rem;
    }
}

@keyframes load6 {
    0% {
        box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    5%,
    95% {
        box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    10%,
    59% {
        box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
    }
    20% {
        box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
    }
    38% {
        box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
    }
    100% {
        box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
}

@keyframes round {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>